// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_article_spam_just_isnt_yogic: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `We'll never share your info. Spam just isn't yogic.`,
    es: `Nunca compartiremos tu información. Hacer spam no es de yogui.`,
  };
  return phrases[locale] || phrases.en || 'article_spam_just_isnt_yogic';
};
